import { environment as prodEnvironment } from './environment.prod';

/**
 * UAT environment inherits as much of the environment.prod.ts file as possible
 * Override environment.prod.ts values by placing specific values after spread operations.
 */
export const environment = {
  ...prodEnvironment,
  name: 'uat',
  production: false,
};
